import React from 'react'

const NotFound = () => (
  <div className='alert-template'>
    <h3>404 not found</h3>
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/components/routes/NotFound.js